import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Tem a certeza que quer desativar os pedidos em direto?',
    enable: 'Tem a certeza que quer ativar os pedidos em direto?',
  },
  form: {
    is_google_business_available: {
      label: 'Google Business disponível',
    },
    is_smart_pricing_configured: {
      label: 'Preços mais baixos do que Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Flyer promocional enviado',
    },
    is_menu_fully_configured: {
      label: 'Todos os itens do menu disponíveis',
    },
    has_offers_on_competitor_platforms: {
      label: 'O restaurante tem ofertas ativas no Wolt, Uber, Lieferando (exceto oferta de entrega grátis)?',
    },
    is_instagram_story_shared: {
      label: 'Story de Instagram partilhada com o proprietário',
    },
    is_order_system_connected_to_website: {
      label: 'Website Foodamigos ligado OU botão de encomenda online no website próprio do restaurante adicionado',
    },
    google_business_connected_by: {
      label: 'Como obtivemos acesso ao Google Business Profile?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Gestor de vendas convidou google@foodamigos.io',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Gestor de vendas enviou o primeiro pedido a partir do telemóvel do proprietário',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'Gestor de integração solicitou o Google Business Profile (o GM não convidou nem solicitou acesso)',
      },
    },
  },
  labels: {
    successful_launch:
      'Para garantir um lançamento bem-sucedido, reveja e resolva os seguintes pontos em aberto. Verificar \n' +
      'esta informação ajudará a evitar potenciais problemas após o restaurante estar ativo.',
    check_errors: 'Verifique os erros para garantir um bom lançamento do restaurante.',
    checkbox_confirmation: 'Confirmo que revi os erros e consinto a ativação deste restaurante.',
  },
  buttons: {
    check_error: 'Verificar Erro',
    confirm_and_activate: 'Confirmar e Ativar',
    cancel: 'Cancelar',
    yes: 'Sim',
    no: 'Não',
  },
  errors: {
    name: {
      title: 'Sem caracteres árabes, chineses, etc. no nome da loja',
      description: 'O nome da loja online inclui caracteres não latinos',
    },
    logo_url: {
      title: 'Logótipo',
      description: 'O logótipo foi carregado para a loja online',
    },
    pictures: {
      title: 'Imagem da galeria',
      description: '≥ 1 imagem da galeria disponível na loja online',
    },
    menu_uploaded: {
      title: 'Menu carregado',
      description: '≥ 1 menu disponível',
    },
    opening_hours: {
      title: 'Horário de funcionamento',
      description: '≥ 1 horário de funcionamento adicionado',
    },
    address: {
      title: 'Morada do restaurante',
      description: 'Rua, cidade, código postal introduzidos',
    },
    upsell_items: {
      title: 'Itens de upsell',
      description: '≥ 3 itens de upsell selecionados',
    },
    master_promo_code: {
      title: 'Código Promocional Principal',
      description: 'Código promocional principal disponível',
    },
    flyers_ordered: {
      title: 'Flyers encomendados',
      description: '≥ 1 pacote de flyers encomendado',
    },
    test_orders: {
      title: 'Pedido de teste enviado',
      description: '≥ 1 pedido de teste realizado',
    },
    stripe_billing: {
      title: 'Conta Stripe',
      description: 'Conta Stripe ligada',
    },
    payments_configured: {
      title: 'Pagamentos configurados',
      description: 'O parceiro ligou um fornecedor de pagamento — obrigatório antes do lançamento',
    },
    adyen_merchant_account: {
      title: 'Conta de comerciante Adyen',
      description:
        'Uma conta de comerciante ativa para o país deste restaurante — necessária para tarifas de cartão nacionais',
    },
    payment_rail_covers_country: {
      title: 'O canal de pagamento cobre o país',
      description: 'As contas de pagamento do parceiro conseguem processar o país deste restaurante',
    },
    identity: {
      title: 'Identidade do restaurante',
      description: 'O tipo de restaurante e a cozinha foram definidos',
    },
    storefront: {
      title: 'Loja criada e domínio ligado',
      description: 'Apenas se o restaurante quiser usar o nosso website',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business ligado',
    },
    billing_payment_method: {
      title: 'Método de pagamento',
      description: 'Adicione um método de pagamento para que a FoodAmigos possa faturar este restaurante mensalmente.',
    },
    billing_license: {
      title: 'Licença',
      description: 'Este restaurante precisa de um Plano Parceiro antes de poder ficar ativo.',
    },
    business_name: {
      title: 'Nome da empresa / do restaurante',
      description: 'O nome apresentado nos termos de utilização e na política de privacidade foi guardado',
    },
    payment_method: {
      title: 'Pagamentos em dinheiro ou online',
      description:
        'O pagamento em dinheiro na recolha ou entrega está ativado, ou os pagamentos online estão verificados',
    },
    stripe_processing_fee: {
      title: 'Taxa de processamento',
      description: 'O parceiro definiu a sua taxa de processamento do Stripe ou confirmou uma margem de 0%',
    },
  },
};
